import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/$org/$project/images/$name/")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/$org/$project/images/$name/$tab", params: { ...params, tab: "overview" } });
  },
});
